<template>
	<div v-loading="loadings.main">
		<div class="content-box mt-3">
			<div class="row">
				<div class="col-md-8">
					<h2>中签数量</h2>
					<curd-table
						:has-delete="true"
						ref="listTable"
						:data-model="itemDataModel"
						:fields="tableFields"
						:kv-filter="{
							active: { k: 'active', t: 'id', v: recordId, lge: '==' },
						}"
						:isFieldChooseble="false"
						@doedit="handleEditItem($event)"
					></curd-table>
				</div>
				<div class="col-md-4">
					<h2>增加中签数量</h2>
					<div class="tips">重复输入的将累加到现有数量</div>
					<div>
						<h4>选择门店</h4>
						<el-radio-group v-model="newInfoForm.store" size="mini">
							<el-radio-button
								:label="store"
								v-for="store in value.stores"
								:key="store._id"
							>{{ store.name }}</el-radio-button>
						</el-radio-group>
						<h4>选择颜色</h4>
						<el-radio-group v-model="newInfoForm.color" size="mini">
							<el-radio-button :label="color" v-for="color in value.colores" :key="color">{{ color }}</el-radio-button>
						</el-radio-group>
					</div>
					<div>
						<table class="table table-sm">
							<thead>
								<tr>
									<th style="width:7em">尺码</th>
									<th style="width:7em">数量</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(model, index) in value.models" :key="index">
									<th>{{ model }}</th>
									<td>
										<el-input
											v-model="newInfoForm.amounts[index]"
											class="form-control"
											size="mini"
											@change="handleFormEdited"
											:disabled="
												newInfoForm.store._id == '' ||
													newInfoForm.color == ''
											"
										/>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="footer" v-loading="loadings.formLoading">
						<el-button size="mini" type="primary" @click="doConfirmAdd()" :disabled="!everEdited">确 定</el-button>
					</div>
				</div>
			</div>
		</div>
		<editor
			:show.sync="editorVisible"
			data-model-name="Active_item"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
		></editor>
	</div>
</template>

<script>
import FieldEditor from "@/components/FieldEditor.vue";
import Editor from "@/components/Editor.vue";
import CurdTable from "@/components/CurdTable.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import CurdPage from "@/mixins/CurdPage.js";

export default {
	mixins: [CurdPage],
	data() {
		return {
			loadings: {
				formLoading: false,
				main: false,
				price: false,
			},
			dataModelNames: ["Active_item", "Active"],
			styles: [],
			everEdited: false,
			rules: {},

			info: {},
			newInfoForm: {
				store: { _id: "", name: "" },
				color: "",
				amounts: [],
			},

			editorVisible: false,
			editorId: "",
			tableFields: [
				{
					name: "color",
					sortable: "custom",
				},
				{
					name: "model",
					sortable: "custom",
				},
				{
					name: "store",
					sortable: "custom",
				},
				{
					name: "amount",
					sortable: "custom",
				},
			],
			itemDataModel: "Active_item",
			editorFields: [
				{
					name: "name",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "model",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "color",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "store",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "amount",
					sortable: "custom",
					col: 6,
				},
			],
			totalModelPreset: [],
		};
	},
	props: {
		dataModel: {
			type: String,
			default: "",
		},
		hasGetTableDataModel: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Object,
			default: () => {
				return {
					name: "",
					_id: "",
					colors: [],
					models: [],
					items: [],
				};
			},
		},
		tableDataModel: {
			type: Object,
			default: () => {
				return {};
			},
		},
		recordId: {
			type: String,
			default: "",
		},
		show: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: "name",
		},
		handlerCtrller: {
			type: String,
			default: "curd",
		},
	},
	mounted() {},
	computed: {
		...mapState(["userPrivilegeMapping"]),
	},
	methods: {
		handleFormEdited() {
			this.everEdited = true;
		},
		handleEditItem(id) {
			console.log("edit", id);
			this.editorId = id;
			this.editorVisible = true;
		},
		doConfirmAdd() {
			if (this.newInfoForm.store._id == "") {
				this.$message.warning("请选择门店");
				return;
			}
			if (this.newInfoForm.color == "") {
				this.$message.warning("请选择颜色");
				return;
			}
			if (!this.everEdited) {
				this.$message.warning("数据无变化");
				return;
			}

			this.loadings.formLoading = true;
			this.$axios
				.post(`/active/do_add_item/${this.recordId}`, this.newInfoForm)
				.then(json => {
					this.loadings.formLoading = false;
					this.refreshTable("listTable");
					this.$message.success("成功");
					this.doResetItemInput();
				})
				.catch(json => {
					this.loadings.formLoading = false;
					this.$message.error(json.data.msg);
				});
		},
		doResetItemInput() {
			this.newInfoForm.amounts.forEach((amount, index) => {
				this.newInfoForm.amounts[index] = 0;
			});
		},
	},
	components: {
		CurdTable,
	},
	watch: {
		value: {
			handler(val) {
				this.info = Object.assign({}, val);
				this.newInfoForm.amounts = [];
				this.info.models.forEach(model => {
					this.newInfoForm.amounts.push(0);
				});
			},
			immediate: true,
		},
	},
};
</script>
